import { ldoApiV1 } from "../api";
import { ApiDownload, downloadSchema } from "../schemas/download";

export const getScenarioFileForDownload = (scenarioId: number, filename: string) =>
  ldoApiV1.getQueryOptions({
    queryKey: ["scenarios", scenarioId, "files", filename, "download"],
    queryFn: async (): Promise<ApiDownload> =>
      downloadSchema.parse(
        await ldoApiV1.fetchJson(`/scenarios/${scenarioId}/files/${filename}/download`)
      ),
  });

export const getBulkExportFileForDownload = (bulkExportId: number, filename: string) =>
  ldoApiV1.getQueryOptions({
    queryKey: ["bulk-exports", bulkExportId, "files", filename, "download"],
    queryFn: async (): Promise<ApiDownload> =>
      downloadSchema.parse(
        await ldoApiV1.fetchJson(`/bulk-exports/${bulkExportId}/files/${filename}/download`)
      ),
  });
